<script>
  import { isExternalUrl, correctedUrl } from "$lib/utilities/url-helpers";

  import ExternalLinkLabel from "$lib/components/ExternalLinkLabel.svelte";
  import { page } from "$app/stores";

  export let url;
  export let size = "md";
  export let iconClass = "";
  export let id;

  let clazz = "";
  export { clazz as class };

  export let haspopup = false;
  export let expanded = false;

  export let text = null;

  let isExternal;
  let linkToRender;
  $: {
    isExternal = isExternalUrl(url, $page.url?.origin);
    linkToRender = correctedUrl(url);
  }
</script>

<a
  class="btn-link {clazz}"
  class:no-underline={isExternal}
  data-sveltekit-reload
  href={linkToRender}
  on:click
  aria-haspopup={haspopup}
  aria-expanded={haspopup ? expanded : null}
  target={isExternal ? "_blank" : null}
  rel={isExternal ? "noopener noreferrer" : null}
  {id}
>
  {#if text && !isExternal}
    {text}
  {:else if text && isExternal}
    <ExternalLinkLabel
      {text}
      iconSize={size}
      iconClass="!inline -mr-[5px] align-top {iconClass}"
      textClass="underline"
    />
  {:else}
    <slot />
  {/if}
</a>
